import React from 'react';
import { useTranslation } from 'react-i18next';
import './UnsavedTimesheetWarningModal.scss';

interface UnsavedTimesheetWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isSaving?: boolean;
}

const UnsavedTimesheetWarningModal: React.FC<UnsavedTimesheetWarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSaving = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <div className="unsaved-timesheet-modal-overlay" onClick={onClose}> 
      <div className="unsaved-timesheet-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{t('UNSAVED_TIMESHEET_WARNING_TITLE')}</h2>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close" disabled={isSaving}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#252525"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-message">{t('UNSAVED_TIMESHEET_CONFIRMATION_MESSAGE')}</p>
        </div>
        <div className="modal-footer">
          <button 
            className="modal-btn modal-btn-secondary" 
            onClick={onClose}
            disabled={isSaving}
            style={{color: 'black'}}
          >
            {t('UNSAVED_TIMESHEET_CANCEL_BUTTON')}
          </button>
          <button 
            className="modal-btn modal-btn-primary" 
            onClick={handleConfirm}
            disabled={isSaving}
          >
            {isSaving ? t('SAVING') : t('UNSAVED_TIMESHEET_SAVE_CONTINUE_BUTTON')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedTimesheetWarningModal;
